import { UserEnrollmentScheduleStatusIcon } from '@/components/UserEnrollmentScheduleStatusIcon';
import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import type React from 'react';
import styles from './index.module.scss';

export const USER_ENROLLMENT_LIST_ITEM = graphql(/* GraphQL */ `
  fragment UserEnrollmentListItem on UserEnrollment {
    id
    startDateText
    endDateText
    scheduleStatus
    scheduleStatusText
    servicePlans{
      name
    }
  }
`);

export type SelectUserEnrollmentPageProps = {
  selectableEmbaUserEnrollments: FragmentType<
    typeof USER_ENROLLMENT_LIST_ITEM
  >[];
  selectUserEnrollment: (embaUserEnrollmentId: string) => Promise<void>;
};

export const SelectUserEnrollmentPage = ({
  selectableEmbaUserEnrollments,
  selectUserEnrollment,
}: SelectUserEnrollmentPageProps) => {
  const userEnrollments = useFragment(
    USER_ENROLLMENT_LIST_ITEM,
    selectableEmbaUserEnrollments,
  );

  return (
    <div className={styles.userEnrollmentListPage}>
      <div className={styles.userEnrollmentListPageInner}>
        <h2 className={styles.userEnrollmentListPageTitle}>開講データ選択</h2>
        {userEnrollments.length === 0 && (
          <div className={styles.userEnrollmentListNoData}>
            開講データがありません
          </div>
        )}
        <ul className={styles.enrollmentList}>
          {userEnrollments.map((userEnrollment) => (
            <li key={userEnrollment.id}>
              <button
                className={styles.enrollmentItem}
                onClick={() => selectUserEnrollment(userEnrollment.id)}
                type="button"
              >
                <div className={styles.enrollmentItemHeaderRow}>
                  <div className={styles.enrollmentItemStatus}>
                    <UserEnrollmentScheduleStatusIcon
                      scheduleStatus={userEnrollment.scheduleStatus}
                      scheduleStatusText={userEnrollment.scheduleStatusText}
                    />
                  </div>
                  <div className={styles.enrollmentTerm}>
                    <span>契約期間</span>
                    {userEnrollment.startDateText} 〜{' '}
                    {userEnrollment.endDateText}
                  </div>
                </div>
                <div className={styles.enrollmentItemServicePlansRow}>
                  {userEnrollment.servicePlans &&
                    userEnrollment.servicePlans.length > 0 && (
                      <div className={styles.servicePlans}>
                        {userEnrollment.servicePlans.map(
                          (servicePlan: { name: string }) => (
                            <div
                              key={servicePlan.name}
                              className={styles.servicePlan}
                            >
                              {servicePlan.name}
                            </div>
                          ),
                        )}
                      </div>
                    )}
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
